import { useQuery } from '@tanstack/react-query'
import { DetailSection, QueryBlock } from '../../core/index.js'
import type { MessagesAdminApi } from '../adminApi.js'
import { ContactsSummary } from '../components/ContactsSummary.js'
import { DeliveryReceiptsList } from '../components/DeliveryReceiptsList.js'
import { InboundTextList } from '../components/InboundTextList.js'

/** How many of the worker's receipts the admin's detail lists. */
const RECEIPTS_SHOWN = 20

/** The admin's read-only view of how a worker is reached beyond the app and where their messages went. */
export function AdminWorkerReachSection({ api, clientId, workerId }: { api: Pick<MessagesAdminApi, 'workerContacts' | 'workerDeliveries' | 'workerInboundTexts'>; clientId: string; workerId: string }) {
  const contacts = useQuery({ queryKey: ['admin', 'worker', clientId, workerId, 'contacts'], queryFn: () => api.workerContacts(clientId, workerId) })
  const deliveries = useQuery({ queryKey: ['admin', 'worker', clientId, workerId, 'deliveries'], queryFn: () => api.workerDeliveries(clientId, workerId) })
  const inbound = useQuery({ queryKey: ['admin', 'worker', clientId, workerId, 'inbound-texts'], queryFn: () => api.workerInboundTexts(clientId, workerId) })
  return (
    <DetailSection title="Reach and deliveries" endpoint="…/contacts · …/deliveries">
      <div className="flex flex-col gap-3">
        <QueryBlock query={contacts} missing="No contacts.">
          {(view) => <ContactsSummary contacts={view} />}
        </QueryBlock>
        <QueryBlock query={deliveries} missing="Nothing delivered.">
          {(receipts) => <DeliveryReceiptsList receipts={receipts.slice(0, RECEIPTS_SHOWN)} empty="Nothing has been delivered beyond the app yet." />}
        </QueryBlock>
        <QueryBlock query={inbound} missing="No replies.">
          {(texts) => <InboundTextList texts={texts.slice(0, RECEIPTS_SHOWN)} empty="No replies by text." />}
        </QueryBlock>
      </div>
    </DetailSection>
  )
}
